module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/auth_fail.190668e7.png";